/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Validation_Company_Type_RequiredInputs */

const en_clients_validation_company_type_required = /** @type {(inputs: Clients_Validation_Company_Type_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Company type is required.`)
};

const pt_br2_clients_validation_company_type_required = /** @type {(inputs: Clients_Validation_Company_Type_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo de empresa é obrigatório.`)
};

/**
* | output |
* | --- |
* | "Company type is required." |
*
* @param {Clients_Validation_Company_Type_RequiredInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const clients_validation_company_type_required = /** @type {((inputs?: Clients_Validation_Company_Type_RequiredInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Validation_Company_Type_RequiredInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_validation_company_type_required(inputs)
	return pt_br2_clients_validation_company_type_required(inputs)
});